import type { ReactNode } from 'react';

export const FilterField = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <label className="flex items-center gap-1.5 rounded-lg border border-[#e3e9f4] bg-white px-3.5 py-2.5 text-[13px] font-semibold text-bzgray-600 max-sm:w-full max-sm:justify-between [&_select]:max-w-[220px] [&_select]:cursor-pointer [&_select]:border-0 [&_select]:bg-transparent [&_select]:text-[13px] [&_select]:font-bold [&_select]:text-bzgray-900 [&_select]:outline-none max-sm:[&_select]:max-w-none max-sm:[&_select]:min-w-0 max-sm:[&_select]:flex-1 max-sm:[&_select]:text-base">
    <span>{label}</span>
    {children}
  </label>
);
